module.exports = __webpack_public_path__ + "media/images/front/hospitals/jfcr-18fe8beb7731bd5d90bd55200a17b97f.jpg";